module.exports = __webpack_public_path__ + "static/media/text.7bd17b11.svg";